module.exports = __webpack_public_path__ + "img/user2.95ed9289.png";